<app-header></app-header>

<div class="remove-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="remove-card">
          <!-- Titre principal -->
          <h1 class="remove-title">Demande de Suppression de Données Personnelles</h1>
          
          <!-- Sous-titre -->
          <h2 class="remove-subtitle">Demander la suppression de mes données :</h2>
          
          <!-- Messages de succès et d'erreur -->
          <div *ngIf="showSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
            <i class="bi bi-check-circle-fill me-2"></i>
            {{ successMessage }}
            <button type="button" class="btn-close" (click)="dismissSuccess()" aria-label="Close"></button>
          </div>
          
          <div *ngIf="showError" class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ errorMessage }}
            <button type="button" class="btn-close" (click)="dismissError()" aria-label="Close"></button>
          </div>

          <!-- Formulaire -->
          <form class="remove-form" (ngSubmit)="onSubmit()" #removeForm="ngForm">
            <div class="form-group mb-4">
              <label for="email" class="form-label">Entrez votre e-mail</label>
              <input 
                type="email" 
                class="form-control" 
                id="email" 
                name="email"
                [(ngModel)]="email"
                required
                email
                #emailInput="ngModel"
                [class.is-invalid]="emailInput.invalid && emailInput.touched">
              <div *ngIf="emailInput.invalid && emailInput.touched" class="invalid-feedback">
                Veuillez entrer une adresse email valide.
              </div>
            </div>
            
            <!-- Section Important -->
            <div class="important-section">
              <h3 class="important-title">Important :</h3>
              <ul class="important-list">
                <li>Un email de confirmation sera envoyé à l'adresse indiquée</li>
                <li>Vous devrez cliquer sur le lien de confirmation pour finaliser la suppression</li>
                <li>Cette action est irréversible une fois confirmée</li>
                <li>Toutes vos données personnelles seront définitivement supprimées de nos systèmes</li>
              </ul>
            </div>
            
            <!-- Note sur le dossier spam -->
            <p class="spam-note">
              Si vous ne recevez pas d'email de notre part, merci de vérifier le dossier "spam" de votre boîte de réception.
            </p>
            
            <!-- Boutons d'action -->
            <div class="action-buttons">
              <button 
                type="submit" 
                class="btn btn-danger remove-btn"
                [disabled]="removeForm.invalid || isSubmitting">
                <span *ngIf="!isSubmitting">Demander la suppression de mes données</span>
                <span *ngIf="isSubmitting">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Traitement en cours...
                </span>
              </button>
              
              <button 
                type="button" 
                class="btn btn-secondary home-btn"
                (click)="goToHome()">
                Retour à l'accueil
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
